import {
  Collapse,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useRouter } from 'next/router'
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { RecommendationsIcon } from '../../../components/uielements/icons/RecommendationsIcon'
import { TtoggleDrawerOnMobile } from '../Sidebar'
import { Configurations } from './configurations'
import { Recommendations } from './recommendations'
import { Reports } from './reports'
import { useStyles } from '../Sidebar.styles'
import { permissionValidation } from '@novafuturltd/shared'

interface Props {
  permissions: string[]
  openDrawer: boolean
  hoverDrawer: boolean
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
  toggleOpen: (open: boolean) => void
}

const RecommendationsEngineSubMenu: FC<Props> = ({
  permissions,
  openDrawer,
  hoverDrawer,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  const classes = useStyles({ openDrawer, hoverDrawer })
  const { pathname } = useRouter()
  const [open, setOpen] = React.useState(
    pathname.includes('recommendations-engine/'),
  )
  const handleClick = () => {
    setOpen(!open)
  }

  return permissionValidation(permissions, [
    'recommendations_engine.reports',
  ]) ? (
    <MenuList aria-labelledby="nested-list-subheader" className={classes.root}>
      <MenuItem
        key="experiments"
        data-test="experiments_sidebar_submenu"
        onClick={handleClick}
        className={classes.menuItem}
        selected={
          !openDrawer &&
          !hoverDrawer &&
          pathname.includes('recommendations-engine/')
        }
      >
        <ListItemIcon>
          <RecommendationsIcon className={classes.icon} />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'sidebar.recommendations.engine.title',
          })}
          hidden={!openDrawer && !hoverDrawer}
        />
        {open ? (
          <ExpandLess
            onClick={() => setOpen(false)}
            className={classes.expandIcon}
          />
        ) : (
          <ExpandMore
            onClick={() => setOpen(true)}
            className={classes.expandIcon}
          />
        )}
      </MenuItem>
      <Collapse in={open} timeout="auto">
        <MenuList disablePadding={true}>
          {permissionValidation(permissions, [
            'recommendations_engine.reports',
          ]) && (
            <Recommendations
              pathname={pathname}
              nested={
                openDrawer || hoverDrawer
                  ? classes.nested
                  : classes.nestedClosed
              }
              toggleDrawerOnMobile={toggleDrawerOnMobile}
            />
          )}
        </MenuList>
      </Collapse>
      <Collapse in={open} timeout="auto">
        <MenuList disablePadding={true}>
          {permissionValidation(permissions, [
            'recommendations_engine.reports',
          ]) && (
            <Configurations
              pathname={pathname}
              nested={
                openDrawer || hoverDrawer
                  ? classes.nested
                  : classes.nestedClosed
              }
              toggleDrawerOnMobile={toggleDrawerOnMobile}
            />
          )}
        </MenuList>
      </Collapse>
      <Collapse in={open} timeout="auto" hidden={!openDrawer && !hoverDrawer}>
        <MenuList disablePadding={true}>
          {permissionValidation(permissions, [
            'recommendations_engine.reports',
          ]) && (
            <Reports
              pathname={pathname}
              nested={
                openDrawer || hoverDrawer
                  ? classes.nested
                  : classes.nestedClosed
              }
              toggleDrawerOnMobile={toggleDrawerOnMobile}
            />
          )}
        </MenuList>
      </Collapse>
    </MenuList>
  ) : null
}

export default RecommendationsEngineSubMenu
